import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import {VM} from '@hetao/scratch-core';
import PaintEditorModalComponent from '../components/paint-editor-modal/paint-editor-modal.jsx';

// import analytics from '../lib/analytics';

import {connect} from 'react-redux';

class PaintEditor extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleUpdateImage',
            'handleUpdateName'
        ]);
        this.state = {
            image: null
        };
    }
    componentDidMount () {
        this.props.image.then((image) => {
            this.setState({ image });
        });
    }
    handleUpdateName (name) {
        this.props.vm.renameCostume(this.props.index, name);
    }
    handleUpdateImage (isVector, image, rotationCenterX, rotationCenterY) {
        if (isVector) {
            this.props.vm.updateSvg(
                this.props.index,
                image,
                rotationCenterX,
                rotationCenterY);
        } else {
            this.props.vm.updateBitmap(
                this.props.index,
                image,
                rotationCenterX,
                rotationCenterY,
                2 /* bitmapResolution */);
        }
    }
    render () {
        if (!this.props.imageId || !this.state.image) return null;
        return (
            <PaintEditorModalComponent
                {...this.props}
                image={this.state.image}
                onUpdateImage={this.handleUpdateImage}
                onUpdateName={this.handleUpdateName}
            />
        );
    }
}

PaintEditor.propTypes = {
    editingTarget: PropTypes.string,
    imageFormat: PropTypes.string.isRequired,
    imageId: PropTypes.string.isRequired,
    index: PropTypes.number,
    name: PropTypes.string,
    rotationCenterX: PropTypes.number,
    rotationCenterY: PropTypes.number,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => {
    const editingTarget = state.scratchGui.vm.editingTarget;
    const targetId = state.scratchGui.vm.editingTarget.id;
    const sprite = state.scratchGui.vm.editingTarget.sprite;

    // Make sure the costume index doesn't go out of range.
    let selectedCostumeIndex = 0;
    if (editingTarget && editingTarget.currentCostume) {
        selectedCostumeIndex = editingTarget.currentCostume;
    }
    const index = selectedCostumeIndex < sprite.costumes.length ?
        selectedCostumeIndex : sprite.costumes.length - 1;
    const costume = state.scratchGui.vm.editingTarget.sprite.costumes[index];
    return {
        index: selectedCostumeIndex,
        name: costume && costume.name,
        rotationCenterX: costume && costume.rotationCenterX,
        rotationCenterY: costume && costume.rotationCenterY,
        imageFormat: costume && costume.dataFormat,
        imageId: targetId && `${targetId}${costume.skinId}`,
        image: state.scratchGui.vm.getCostume(index),
        vm: state.scratchGui.vm
    };
};

export default connect(
    mapStateToProps
)(PaintEditor);
